import axios from 'axios'
import { CLIENTES_ENDPOINT } from 'cfgCommon/endpoints'

export async function getClientWithOpportunities(id) {
  const response = await axios(`${CLIENTES_ENDPOINT}/withOpportunities/${id}`)
  return response?.data
}
